import React, { useState, useEffect, useCallback, useRef } from 'react';
import moment from 'moment';
import { useIntl } from 'umi';
import Filter from '@/pages/intelligence/components/Filter';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { STATIC_FILTER_CONFIGS, DEFAULT_FORM_VALUE } from './config';
import { feachTimeTypeToFilterTimeType } from '@/pages/intelligence/utils/common';
import { GuideGenreMarketProfileDelay as GuideGenreMarketProfile } from '@intelligence/components/UserGuide/GenreMarketProfile';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import { genreProfileStats } from '@intelligence/v3/constants/downloadLogPoint';

export default function StatsFilters(props: any) {
  const {
    isMarketSegmentHide,
    filterValues = {},
    regionOpts,
    onFilterChange,
    genreSource,
    total,
    genreName,
    genreType,
    order,
    orderBy,
    metricsList,
    entityType = '',
    defaultValue,
    requestParams,
    downloadPageFun,
  } = props;

  const { formatMessage } = useIntl();

  const formValueRef = useRef(JSON.parse(JSON.stringify(DEFAULT_FORM_VALUE)));

  const [inputList, setInputList] = useState([
    {
      ...STATIC_FILTER_CONFIGS.REGION,
      entityType,
    },
    {
      ...STATIC_FILTER_CONFIGS.RANGE_TIME,
      entityType,
    },
    {
      ...STATIC_FILTER_CONFIGS.DATASOURCESIM,
      entityType,
    },
  ]);

  const handleFilterChange = (
    value /** 筛选器数据 */,
    apiValue /** 筛选器转换后的数据 */,
  ) => {
    const { rangeTime, region, ...rest } = apiValue || {};
    const { start_date, end_date, granularity } = rangeTime;
    const { regions, markets } = region;
    onFilterChange({
      type: 'cascade',
      payload: {
        start_date,
        end_date,
        granularity,
        regions,
        markets,
        ...rest,
      },
    });
  };

  const onReset = useCallback((value) => {
    // console.log(value);
  }, []);

  useEffect(() => {
    const tempList = [...inputList];
    tempList[0].options = regionOpts;
    setInputList(tempList);
  }, [regionOpts]);

  /** 时间筛选器值由父组件更新 */
  useEffect(() => {
    formValueRef.current = {
      region: {
        regions: filterValues.regions,
        markets: filterValues.markets,
        type: 'market',
      },
      rangeTime: {
        type: feachTimeTypeToFilterTimeType(filterValues.granularity),
        value: [moment(filterValues.startDate), moment(filterValues.endDate)],
      },
    };
  }, [filterValues.endDate, filterValues.regions]);

  //   下载需要的接口参数
  const getGenresReqParams = useCallback(() => {
    // // 初始化使用iegg字段传入
    // // let genresParams;
    const paramsTemp = {
      data_category: filterValues.dimension,
      market_type: filterValues.marketType,
      genre_source: genreSource,
      start_date: filterValues.startDate,
      end_date: filterValues.endDate,
      granularity: filterValues.granularity,
      regions: filterValues.markets,
      data_tag: filterValues.dimension,
      genre_tab: genreType,
      genre: genreName,
      metrics: metricsList,
      order_by: orderBy,
      order,
      requestParams,
      dataSource: filterValues.dataSourceSingle?.value,
    };
    return paramsTemp;
  }, [
    filterValues,
    genreSource,
    genreType,
    genreName,
    metricsList,
    orderBy,
    requestParams,
  ]);

  return (
    <>
      <div className="dbi-genre-rowtop">
        <div className="dbi-genre-rowtop-left">
          <Filter
            value={formValueRef.current}
            inputList={inputList}
            onConfirm={handleFilterChange}
            onReset={onReset}
            defaultValue={defaultValue}
            showButton={false}
          />
          <TipContext
            className="tip-text-hd"
            tipText={formatMessage({
              id:
                filterValues.marketType === 'mobile'
                  ? 'dbi_genre_profile_stats_mobile_info'
                  : 'dbi_genre_profile_stats_mscience_info',
            })}
          />
        </div>
        <ExportTable
          downloadModalSize={820}
          entityType={'mobile'}
          businessType="genre-profile-detail"
          isDisableDownload={false}
          downloadLogConfigKey={
            genreProfileStats?.[`${entityType}_${filterValues.dimension}`]
          }
          total={total}
          tableParams={getGenresReqParams()}
          newStyleFileName={`Genre Profile_${genreName}`}
          downloadKey={'genreProfileDetailStats'}
          downloadPageFun={downloadPageFun}
        />
      </div>
      {!isMarketSegmentHide && <GuideGenreMarketProfile />}
    </>
  );
}
